// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getImageFilePath } from '@tcp/core/src/utils';

const styles = css`
  .imageSize {
    width: 60px;
    height: 60px;
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    background-size: contain;
    background-repeat: no-repeat;
  }

  .firstColImage {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    @media ${(props) => props.theme.mediaQuery.large} {
      flex-direction: row;
    }
  }
  .imageSizeSingle {
    width: 60px;
    height: 92px;
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    background-size: contain;
    background-repeat: no-repeat;
  }
  .AppDownload,
  .Gymboree_AppDownload,
  .Tcp_AppDownload,
  .Snj_AppDownload,
  .Pjp_AppDownload {
    background-image: url('${(props) => getImageFilePath(props)}/app_download.svg');
  }
  .ProductReview,
  .Gymboree_ProductReview,
  .Tcp_ProductReview,
  .Snj_ProductReview,
  .Pjp_ProductReview {
    background-image: url('${(props) => getImageFilePath(props)}/review.svg');
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }
  .FacebookLink,
  .Gymboree_FacebookLink,
  .Tcp_FacebookLink,
  .Snj_FacebookLink,
  .Pjp_FacebookLink {
    background-image: url('${(props) => getImageFilePath(props)}/facebook.png');
  }
  .InstagramLink,
  .Gymboree_InstagramLink,
  .Tcp_InstagramLink,
  .Snj_InstagramLink {
    background-image: url('${(props) => getImageFilePath(props)}/instagram.png');
  }
  .ChildProfile {
    background-image: url('${(props) => getImageFilePath(props)}/child-birthday-profile.png');
  }
  .SMSOptIn,
  .Gymboree_SMSOptIn,
  .Tcp_SMSOptIn,
  .Snj_SMSOptIn,
  .Pjp_SMSOptIn {
    background-image: url('${(props) => getImageFilePath(props)}/sms.svg');
  }
  .AddMailingAddress {
    background-image: url('${(props) => getImageFilePath(props)}/mailingAddress.svg');
  }
  .AddFavoriteStore {
    background-image: url('${(props) => getImageFilePath(props)}/store.svg');
  }
  .AddShopperType {
    background-image: url('${(props) => getImageFilePath(props)}/feedback_survey.svg');
  }
  .AddBirthDate {
    background-image: url('${(props) => getImageFilePath(props)}/birthdays.svg');
  }
  .FeedbackSurvey {
    background-image: url('${(props) => getImageFilePath(props)}/oval.svg');
  }
  .TwitterLink,
  .Gymboree_TwitterLink,
  .Tcp_TwitterLink,
  .Snj_TwitterLink {
    background-image: url('${(props) => getImageFilePath(props)}/twitter_3x.png');
  }
  .TwitterPhoto,
  .Gymboree_TwitterPhoto,
  .Tcp_TwitterPhoto,
  .Snj_TwitterPhoto,
  .Pjp_TwitterLink {
    background-image: url('${(props) => getImageFilePath(props)}/share-twitter.png');
  }

  .tileWrapper {
    border: 1px solid ${(props) => props.theme.colorPalette.gray[300]};
    background: ${(props) => props.theme.colors.WHITE};
    margin-left: ${(props) => (props.viewAll ? '' : props.theme.spacing.ELEM_SPACING.SM)};
    margin-right: ${(props) => (props.viewAll ? '' : props.theme.spacing.ELEM_SPACING.SM)};
    margin-bottom: ${(props) => (props.viewAll ? props.theme.spacing.ELEM_SPACING.LRG : '')};
    box-shadow: 0 0 10px 0 ${(props) => props.theme.colors.NEWDESIGN_BOX_SHADOW_3};
    cursor: pointer;
    min-height: ${(props) => (props.viewAll ? '240px' : '')};
    border-bottom: 2px solid
      ${(props) => props.theme.brandSpecificStyles.BORDER_BOTTOM_FOR_EARN_EXTRA_POINTS};

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-left: ${(props) => (props.viewAll ? '' : props.theme.spacing.LAYOUT_SPACING.MED)};
      margin-right: ${(props) => (props.viewAll ? '' : props.theme.spacing.LAYOUT_SPACING.MED)};
      min-height: 277px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-left: ${(props) => (props.viewAll ? '' : props.theme.spacing.ELEM_SPACING.XL)};
      margin-right: ${(props) => (props.viewAll ? '' : props.theme.spacing.ELEM_SPACING.XL)};
    }
  }

  .earnPointDesc {
    margin-bottom: ${(props) =>
      props.viewAll
        ? props.theme.spacing.ELEM_SPACING.XXL
        : props.theme.spacing.LAYOUT_SPACING.LRG};
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-bottom: 0;
    }
  }

  .activityTitleMargin {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: 0;
      padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
  }

  .earnExtraPointsTileImage {
    margin-top: ${(props) =>
      props.viewAll ? props.theme.spacing.ELEM_SPACING.XL : props.theme.spacing.LAYOUT_SPACING.MED};
    height: 96px;
    text-align: center;
    display: flex;
    justify-content: space-around;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: ${(props) => props.theme.spacing.LAYOUT_SPACING.MED};
    }
  }

  .earnExtraPointsTileImageSingle {
    display: flex;
    justify-content: center;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-right: ${(props) => (props.viewAll ? props.theme.spacing.LAYOUT_SPACING.MED : '')};
    }
  }
  .earnExtraPointsTileTextMargin {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-right: ${(props) => props.theme.spacing.LAYOUT_SPACING.LRG};
    }
  }
  ${(props) =>
    props.isNewEarnExtraPoint
      ? `
    flex-basis: 23.7%;
  &:not(:first-child) {
    margin-left: ${props.theme.spacing.ELEM_SPACING.MED};
  }
  .tileWrapper{
     margin-bottom: 0;
    padding: 16px;
    min-height: 135px;
    border-bottom:0;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
  .earnExtraPointsTileImage{
    margin:0;
    height:auto;
  }
  @media ${props.theme.mediaQuery.mediumOnly} {
    flex-basis: 23%;
    .earnPointDesc{
      padding:0;
      margin:0;
    }
  }
  `
      : ''}

  ${(props) =>
    props.isAccountDrawer || props.isNewEarnExtraPoint
      ? `
      @media ${
        props.isAccountDrawer ? props.theme.mediaQuery.small : props.theme.mediaQuery.smallOnly
      } {
  flex-basis: 47%;
  &:not(:first-child) {
    margin-left: 0;
  }
  &:nth-child(odd) {
    margin-left: 0;
    margin-right: 15px;
  }
  &:nth-child(even) {
    margin-right: 0;
  }
  .tileWrapper{
    margin-bottom: 0;
    margin-top: ${props.theme.spacing.ELEM_SPACING.MED};
    padding: ${props.theme.spacing.ELEM_SPACING.XS};
    min-height: 135px;
    border-bottom:0;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
    border-radius: ${props.theme.spacing.ELEM_SPACING.XS};
  }
  .earnExtraPointsTileImage{
    margin:0;
    height:auto;
    margin-top: ${props.theme.spacing.ELEM_SPACING.XS_1};
  }
  .imageSize {
    width: 30px;
    height: 30px;
    margin-left: 0;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .earn-activityTitle{
    flex-basis: 45%;
    margin-top:  ${props.theme.spacing.ELEM_SPACING.REG};
    font-family: ${props.theme.typography.fonts.secondary};
    font-weight: ${props.theme.typography.fontWeights.bold};
    font-size: ${props.theme.typography.fontSizes.fs16};
    color: ${props.theme.colorPalette.gray[900]};
  }
  .earnPointDesc {
    margin: 0;
    padding: 0;
    margin-top: ${props.theme.spacing.ELEM_SPACING.XS_6};
    flex-basis: 40%;
    font-family: ${props.theme.typography.fonts.secondary};
    font-weight: ${props.theme.typography.fontWeights.regular};
    font-size: ${props.theme.typography.fontSizes.fs16};
    color: ${props.theme.colorPalette.gray[900]};
  }
}
  `
      : ''}
  ${(props) =>
    props.isAccountDrawer || props.isNewEarnExtraPoint
      ? `
  @media ${props.theme.mediaQuery.smallOnly} {
    flex-basis: 47%;
    flex-wrap: wrap;
    margin-left: 0!important;
    .tileWrapper{
      margin-bottom: 0;
      margin-top: ${props.theme.spacing.ELEM_SPACING.MED};
      padding: ${props.theme.spacing.ELEM_SPACING.MED};
      min-height: 135px;
      border-bottom:0;
      box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
      border-radius: ${props.theme.spacing.ELEM_SPACING.XS};
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    .earnExtraPointsTileImage {
      margin: 0;
      flex-basis: 25%;
      height: auto;
      justify-content: flex-start;
    }
  }
  `
      : ''}
`;

export default styles;
